module.exports = __webpack_public_path__ + "assets/images/a0f51dbfa8c16f03768cee1c3e4700e1.svg";